import {useState} from 'react'

const useEditMode = (data, formikProps, index) => {
    const [draftData, setDraftData] = useState([...formikProps.values.values[index].cardData])
    const [editorOpen, setEditorOpen] = useState(false)

    const handleSave = (newValue) => {
        setDraftData(newValue)
        formikProps.setFieldValue(`values[${index}].cardData`, newValue)
    }

    return {editorOpen, setEditorOpen, draftData, setDraftData, handleSave}
}

export default useEditMode